import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {catalogService, shoppingService} from "api";
import {toArray} from "helper/common";
import {LOAI_FORM} from "types/enums";
export interface State {
  typeFormShopping: LOAI_FORM;
  typeFormPay: LOAI_FORM;
  idProposeShopping: any;
  idProposePay: any;
  detailProposeShopping: any;
  detailProposePay: any;
  listNhaCungCap: any[];
  listDongNganSach: any[];
  listNguonThanhToan: any[];
  listDuAn: any[];
}

const initialState: State = {
  typeFormShopping: LOAI_FORM.TAO_MOI,
  typeFormPay: LOAI_FORM.TAO_MOI,
  idProposeShopping: null,
  idProposePay: null,
  detailProposeShopping: null,
  detailProposePay: null,
  listNhaCungCap: [],
  listDongNganSach: [],
  listNguonThanhToan: [],
  listDuAn: [],
};

export const proposeShoppingSlice = createSlice({
  name: "proposeShopping",
  initialState: initialState,
  reducers: {
    setIdProposeShopping: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.idProposeShopping = action.payload;
    },
    setIdProposePay: (state = initialState, action: PayloadAction<any>) => {
      state.idProposePay = action.payload;
    },
    setTypeFormShopping: (state = initialState, action: PayloadAction<any>) => {
      state.typeFormShopping = action.payload;
    },
    setTypeFormPay: (state = initialState, action: PayloadAction<any>) => {
      state.typeFormPay = action.payload;
    },
    setDetailShopping: (state = initialState, action: PayloadAction<any>) => {
      state.detailProposeShopping = action.payload;
    },
    setDetailPay: (state = initialState, action: PayloadAction<any>) => {
      state.detailProposePay = action.payload;
    },
    setListNhaCungCap: (state = initialState, action: PayloadAction<any>) => {
      state.listNhaCungCap = action.payload;
    },
    setListDongNganSach: (state = initialState, action: PayloadAction<any>) => {
      state.listDongNganSach = action.payload;
    },
    setListNguonThanhToan: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      state.listNguonThanhToan = action.payload;
    },
    setListDuAn: (state = initialState, action: PayloadAction<any>) => {
      state.listDuAn = action.payload;
    },
  },
});

export const {
  setIdProposeShopping,
  setIdProposePay,
  setTypeFormShopping,
  setTypeFormPay,
  setDetailShopping,
  setDetailPay,
  setListNhaCungCap,
  setListDongNganSach,
  setListNguonThanhToan,
  setListDuAn,
} = proposeShoppingSlice.actions;

export default proposeShoppingSlice.reducer;
export const getDetailProposeShopping = id => {
  return async dispatch => {
    try {
      const res = await shoppingService.getDetailProposeShopping(id);
      dispatch(setDetailShopping(res));
    } catch (error) {
      dispatch(setDetailShopping(null));
    }
  };
};
export const getDetailProposePay = id => {
  return async dispatch => {
    try {
      const res = await shoppingService.getDetailProposePay(id);
      dispatch(setDetailPay(res));
    } catch (error) {
      dispatch(setDetailPay(null));
    }
  };
};
export const getListNhaCungCap = (params = {page: 1, limit: 50}) => {
  return async dispatch => {
    try {
      const res = await shoppingService.getListSupplier(params);
      dispatch(setListNhaCungCap(toArray(res?.data)));
    } catch (error) {
      dispatch(setListNhaCungCap([]));
    }
  };
};
export const getListDongNganSach = (params = {page: 1, limit: 50}) => {
  return async dispatch => {
    try {
      const res = await shoppingService.getListNguonNganSach(params);
      dispatch(setListDongNganSach(toArray(res?.data)));
    } catch (error) {
      dispatch(setListDongNganSach([]));
    }
  };
};
export const getListNguonThanhToan = (params = {page: 1, limit: 50}) => {
  return async dispatch => {
    try {
      const res = await shoppingService.getListNguonThanhToan(params);
      dispatch(setListNguonThanhToan(toArray(res?.data)));
    } catch (error) {
      dispatch(setListNguonThanhToan([]));
    }
  };
};
export const getListDuAn = (params = {page: 1, limit: 50}) => {
  return async dispatch => {
    try {
      const res = await shoppingService.getListDuAn(params);
      dispatch(setListDuAn(toArray(res?.data)));
    } catch (error) {
      dispatch(setListDuAn([]));
    }
  };
};
